// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3IrPZ","list":"BalanceDue_list__izhQp","listRow":"BalanceDue_listRow__2UgFA","total":"BalanceDue_total__17gHn"};